<template>
	<b-card no-body no-header class="posCard">
		<div slot="header" class="d-flex custom-card-header pos-card-header">
			<div class="d-flex align-items-center">
				<!--<b-link to="../" variant="outline-dark"
						v-b-tooltip.hover :title="$t('back')"
				>
					<i class="fa fa-arrow-left"></i>
				</b-link>-->
				<h5 class="card-header-title">{{ headerTitle  }} </h5>
			</div>

			<div class="card-header-actions" style="display: flex;align-items: center">
				<h6 class="mb-0" v-if="suspendActive">Чек №: <span
					:class="suspendActive ? 'suspendActive':''">{{ currentSaleSuspendNumber }}</span>
				</h6>
				<h6 class="mb-0" v-else>Чек №: <span>{{ saleNumber }}</span>
				</h6>
				<button class="mb-0 btn btn-info btn-sm d-flex align-items-center justify-content-center"
						v-if="suspendActive"
						style="margin-left: 10px;height: 22px;padding: 2px 10px"
						v-b-tooltip.hover :title="$t('pos.returnToPos')"
						@click="goToPos">
					<i class="fa fa-backward mr-1"></i> POS
				</button>
				<!--<b-link class="mb-0 btn btn-success btn-sm d-flex align-items-center justify-content-center"
						style="margin-left: 10px;height: 22px;padding: 2px 10px"
						v-b-tooltip.hover :title="$t('pos.openNewPos')"
						to="/point-of-sale/pos"
						target="_blank"
						@click="$emit('newPosOpened')"
				>
					<i class="fa fa-plus mr-1"></i> <strong>POS</strong>
				</b-link>-->
				<!--				<h6 class="mb-0" v-else>Savdo №: {{ saleNumber }}</h6>-->
			</div>
		</div>
		<b-card-body class="bv-example-row bv-example-row-flex-cols cardBody">
			<b-row align-v="start">
				<!-- DEFAULT SLOT -->
				<slot></slot>
			</b-row>

			<b-row align-v="end">
				<!-- SLOT FOR ITEMS -->
				<slot name="items">
				</slot>
			</b-row>
		</b-card-body>
	</b-card>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
		name: "CardForPos",
		props: {
			suspendActive: {
				type: Boolean,
				default: false
			},
			saleNumber: String,
			headerTitle: {
				type: String,
				default: '#Default Card Header'
			},
			filter: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				// suspendActive: false,
				message: ""
			}
		},
		methods: {
			...mapActions('clients', [
				'emptyObjectStore'
			]),
			showCreateModal() {
				this.$emit('create');
			},
			filterChanged(newVal) {
				this.$emit('filterChanged', newVal);
			},
			clearFilter() {
				this.$emit('clearFilter');
			},
			goToPos() {
				this.suspendActive = false;
				this.$emit('changeSuspendActive', false);
				this.$store.commit('wholesalePos/resetState');
				this.$store.commit('wholesalePos/resetSuspendId');
				const emptyObject = {};
				this.emptyObjectStore(emptyObject);
				this.$emit("searchBarFocus");
			},
		},
		mounted() {
			/*Fire.$on('activeEmit', (data) => {
				this.suspendActive = data.suspendActive
				this.message = data.message;
			})*/
		},
		computed: {
			...mapState('wholesalePos', [
				'currentSaleSuspendNumber'
			]),
			...mapState(['isCashier']),
		}
	}
</script>

<style scoped lang="scss">
	.cardBody {
		flex-direction: column;

		.row {
			flex-direction: column;
		}
	}

	.card-header-title {
		margin-left: 1rem;
	}

	.custom-card-header {
		a {
			text-decoration: none;

			i {
				vertical-align: middle;
			}
		}
	}

	.suspendActive {
		color: orange;
		font-weight: bold;
	}
</style>
